var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React, { useState, useEffect } from 'react';
import { ColorPicker } from "../../../../Components/Forms/ColorPicker";
import { InputField } from "../../../../Components/Forms/InputField";
import { Checkbox } from "../../../../Components/Forms/Checkbox";
import { Select } from "../../../../Components/Forms/Select";
import { Translate } from "../../../../../I18N/Translate";

const templateColors = [
'#628ccf',
'#ff8282',
'#ff8a4c',
'#faca15',
'#16bdca',
'#31c48d',
'#9eb0fd',
'#f17eb8',
'#ac94fa',
'#9ca3af'];
















export const TemplateMetadata = ({
  value,
  onChange,
  pages,
  nameError,
  colorError
}) => {
  const [displayAsPage, setDisplayAsPage] = useState(!!value.entityViewPage);

  useEffect(() => {
    // If entityViewPage is set externally, enable checkbox
    if (value.entityViewPage && !displayAsPage) {
      setDisplayAsPage(true);
    }
    // If entityViewPage is cleared externally, disable checkbox
    if (!value.entityViewPage && displayAsPage) {
      setDisplayAsPage(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value.entityViewPage]);

  const handleCheckboxChange = (checked) => {
    setDisplayAsPage(checked);
    if (!checked) {
      onChange(_objectSpread(_objectSpread({}, value), {}, { entityViewPage: '' }));
    }
  };

  return (/*#__PURE__*/
    _jsx("div", { className: "flex gap-3 w-full py-2" }, void 0, /*#__PURE__*/
    _jsx(ColorPicker, {
      name: "template-color",
      value: value.color,
      onChange: (color) => onChange(_objectSpread(_objectSpread({}, value), {}, { color })),
      hasErrors: !!colorError,
      options: templateColors }
    ), /*#__PURE__*/
    _jsx(InputField, {
      id: "template-name",
      name: "template-name",
      placeholder: "Template name",
      value: value.name,
      onChange: (e) => onChange(_objectSpread(_objectSpread({}, value), {}, { name: e.target.value })),
      className: "flex-grow min-w-[120px]",
      clearFieldAction: value.name ? () => onChange(_objectSpread(_objectSpread({}, value), {}, { name: '' })) : undefined,
      hasErrors: !!nameError,
      errorMessage:
      nameError && value.name ? /*#__PURE__*/_jsx(Translate, {}, void 0, "Template name already exists") : '' }

    ), /*#__PURE__*/
    _jsx("div", { className: "flex items-center h-10 gap-2 ml-4" }, void 0,
    !pages.length && /*#__PURE__*/
    _jsx(Translate, { className: "text-sm font-medium text-gray-900" }, void 0, "There are no pages enabled for entity view"

    ),

    Boolean(pages.length) && /*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx(Checkbox, {
      name: "display-as-page",
      checked: displayAsPage,
      onChange: (e) => handleCheckboxChange(e.target.checked),
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Display entity view from page"),
      className: "mb-0" }
    ), /*#__PURE__*/
    _jsx(Select, {
      id: "select-page",
      label: "",
      options: [{ value: '', label: 'Select page' }, ...pages],
      value: value.entityViewPage,
      onChange: (e) => onChange(_objectSpread(_objectSpread({}, value), {}, { entityViewPage: e.target.value })),
      disabled: !displayAsPage,
      className: "w-36",
      hideLabel: true }
    )
    )

    )
    ));

};